module.exports = __webpack_public_path__ + "img/logo.a1a34b5c.png";